import { useTranslations } from '@aikoa/i18n/react'
import { View } from 'react-native'
import type { Source } from '~/components/source-viewer/types'
import { cn } from '~/lib/utils'

interface PdfViewerProps {
  source: Source
  onLoad: () => void
  onError: (error: string) => void
  className?: string
}

export default function PdfViewer({ source, onLoad, onError, className }: PdfViewerProps) {
  const { t } = useTranslations('sourceViewer')

  return (
    <View className={cn('flex-1', className)}>
      <iframe
        title={t(($) => $.pdf.title)}
        src={source}
        width="100%"
        height="100%"
        onLoad={onLoad}
        onInvalid={() => onError(t(($) => $.pdf.loadFailed))}
        onError={() => onError(t(($) => $.pdf.loadFailed))}
        aria-label={t(($) => $.pdf.title)}>
        <View className="flex h-full flex-col items-center justify-center bg-muted p-4 text-center">
          <p className="font-semibold">{t(($) => $.pdf.previewFailed)}</p>
          <p className="text-sm text-secondary">{t(($) => $.pdf.browserNotSupported)}</p>
        </View>
      </iframe>
    </View>
  )
}
